/* tslint:disable */

declare var Object: any;
export interface TtamattstatusInterface {
  "attendCode": string;
  "attendNameEn": string;
  "attendNameId": string;
  "attendNameMy": string;
  "attendNameTh": string;
  "presentFlag": string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "orderno"?: number;
}

export class Ttamattstatus implements TtamattstatusInterface {
  "attendCode": string;
  "attendNameEn": string;
  "attendNameId": string;
  "attendNameMy": string;
  "attendNameTh": string;
  "presentFlag": string;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "orderno": number;
  constructor(data?: TtamattstatusInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttamattstatus`.
   */
  public static getModelName() {
    return "Ttamattstatus";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttamattstatus for dynamic purposes.
  **/
  public static factory(data: TtamattstatusInterface): Ttamattstatus{
    return new Ttamattstatus(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttamattstatus',
      plural: 'Ttamattstatuses',
      path: 'Ttamattstatuses',
      properties: {
        "attendCode": {
          name: 'attendCode',
          type: 'string'
        },
        "attendNameEn": {
          name: 'attendNameEn',
          type: 'string'
        },
        "attendNameId": {
          name: 'attendNameId',
          type: 'string'
        },
        "attendNameMy": {
          name: 'attendNameMy',
          type: 'string'
        },
        "attendNameTh": {
          name: 'attendNameTh',
          type: 'string'
        },
        "presentFlag": {
          name: 'presentFlag',
          type: 'string'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "orderno": {
          name: 'orderno',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttamattstatus.ts